module.exports = __webpack_public_path__ + "assets/8f9d5081442cca8a399859a62d71d2786.jpg";